<template>
  <div class="flex flex-col h-full">
    <p class="text-sm bg-blue-100 p-4 rounded mt-2">
      <strong>מערכת התשלומים הרשמית של טיימאיט! 🎉</strong><br />
      התחברנו לPayme כדי לאפשר לכם לקבל תשלום ולשלוח חשבוניות בקלות ופשטות עם כל האשרויות שרציתם, והכל במקום אחד!
    </p>

    <div class="mb-6 p-4">
      <div class="flex items-start gap-2">
        <i class="pi pi-info-circle mt-0.5"></i>
        <div class="text-sm">
          <p class="font-semibold mb-1">מה תצטרכו:</p>
          <ul class="list-disc mr-5 space-y-1">
            <li>תעודת זהות ופרטים אישיים</li>
            <li>פרטי חשבון בנק לקבלת התשלומים</li>
            <li>כתובת העסק</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="w-full mt-auto flex flex-col gap-2">
      <Button
        label="בואו נתחיל"
        style="display: flex; flex-grow: 1"
        @click="$emit('next')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
defineEmits(['next']);
</script>

<style scoped lang="scss">
</style>
